<template>
  <Form function-type="create"/>
</template>

<script>
import Form from './Form';

export default {
  name: "Create",
  components: {Form},
}
</script>

<style scoped>

</style>